import dynamic from "next/dynamic";

export const JobsCarouselJoinUs = dynamic(() => import("./component"));
